import { generateUtilityClasses } from '@mui/material';

export const paginationClasses = generateUtilityClasses('Pagination', ['root']);
